import { APP_PERMISSIONS } from '@exam-center/permission';
import { useHasPermission } from '@shared/permissions';

import { ExamCenterDetailsFormLogic } from '../exam-center-details-form-logic';
import { ExamCenterReadonlyDetails } from '../exam-center-readonly-details';

export default function ExamCenterDetails() {
  const shouldDisplayEditForm = useHasPermission(
    APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.EXAM_CENTER.UPDATE,
  );

  if (shouldDisplayEditForm) {
    return <ExamCenterDetailsFormLogic />;
  }

  return <ExamCenterReadonlyDetails />;
}
